import React from 'react';

const renderTableBody = (headers, data, checkbox, openDetails) => {
    let body = "";

    body = data.map((register, index) => {
        
        let role = '';
        if(register.U_FMB_role === 'branch1'){
        role = 'BRANCH'
        }else if(register.U_FMB_role === 'counter1'){
        role = 'COUNTER'
        }
        else if(register.U_FMB_role === 'admin1'){
        role = 'ADMINISTRADOR'
        }

        return (
            <tr key={index}>
                <td className="sticky-column">
                    <input type="checkbox" style={{minWidth: '100%'}} id="cbox2"
                            checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)}/>
                </td>
                {headers[0].value && <td>{register.USER_CODE}</td>}
                {headers[1].value && <td>{register.U_NAME}</td>}
                {headers[2].value && <td>{register.E_Mail}</td>}
                {headers[3].value && <td>{role}</td>}
                {headers[4].value && <td>{register.GroupName}</td>}
                {headers[5].value && <td>{register.Currency}</td>}
                {headers[6].value && <td>{register.LicTradNum}</td>}
                <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                            onClick={() => openDetails({User: register.USERID, index})}
                            style={{fontWeight: '500'}}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        )
        
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-column" style={{backgroundColor: "#e9ecef"}}>
                <input type="checkbox" style={{minWidth: '100%'}} id="cbox2" value="second_checkbox"
                       onChange={(event) => checkbox.selectAll(event.target.checked)}/>
            </td>
            {headers[0].value && <td>{headers[0].title}</td>}
            {headers[1].value && <td>{headers[1].title}</td>}
            {headers[2].value && <td>{headers[2].title}</td>}
            {headers[3].value && <td>{headers[3].title}</td>}
            {headers[4].value && <td>{headers[4].title}</td>}
            {headers[5].value && <td>{headers[5].title}</td>}
            {headers[6].value && <td>{headers[6].title}</td>}
            <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>Acciones</td>

        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{width: '100%'}}>
        <thead className="table-header">
        {header}
        </thead>
        <tbody>
        {body}
        </tbody>
    </table>;

    return table;

};

export const renderTableUsers = (headers, data, checkbox, openDetails) => {

    return renderTable(headers, data, checkbox, openDetails);

}
